import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemProperties',
  props: {
    properties: {
        required: false,
        default: null,
        validator: prop => typeof prop === 'string' || prop === null,
        type: String
    },
    orderNumber: { required: true, type: String }
},
  setup(__props) {



return { __sfc: true, }
}

})